import React, { useEffect, useState } from "react";
import { Card, CardBody, Row, Col } from "reactstrap";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import PhoneInTalkRoundedIcon from "@mui/icons-material/PhoneInTalkRounded";
import CreditCardRoundedIcon from "@mui/icons-material/CreditCardRounded";
import { useSelector } from "react-redux";
// import { viewDoc } from 'path/to/viewDoc'; // <- make sure to import this

export default function CustomerProfileCard({
  customerData,
  dispatch,
  customerId,
  setLoading,
}) {
  const firstName = customerData?.customerInfo?.firstName || "";
  const lastName = customerData?.customerInfo?.lastName || "";
  const fullName = `${firstName} ${lastName}`.trim() || "Guest";
  const initials = getInitials(firstName, lastName);
  const contact = customerData?.customerInfo?.mobile
    ? `${customerData?.customerInfo?.dialCode || ""}-${
        customerData?.customerInfo?.mobile
      }`
    : "-";
  const account = customerData?.customerInfo?.customerId || "-";

  const [profileData, setProfileData] = useState(false);

  useEffect(() => {
    // ensure viewDoc is imported or defined
    try {
      let partnerOrCustomer = "Customer";
      dispatch(
        viewDoc(
          setLoading,
          customerId,
          "logo",
          partnerOrCustomer,
          setProfileData
        )
      );
    } catch (err) {
      // swallow so it doesn't break render — log for debug
      // console.error("viewDoc dispatch failed", err);
    }
  }, [dispatch, customerId, setLoading]);

  const profile = useSelector((state) => state.ViewDocument?.documentView);
  const base64ImageData = profile?.filePath;

  return (
    <div className="">
      <Card
        className="shadow-lg w-100 customer-card"
        style={{ border: "0.1px solid #FD754533", borderRadius: "10px" }}
      >
        <CardBody>
          <h5 className="customer-title">Customer Details</h5>

          <Row className="text-left">
            {/* Avatar */}
            <Col md={3} className="d-flex justify-content-center">
              <div className="profile-wrapper">
                <div className="avatar-outer">
                  <div className="profile-avatar">
                    {profileData ? (
                      <img
                        src={base64ImageData}
                        alt="profile"
                        className="profile-image"
                      />
                    ) : (
                      initials
                    )}
                  </div>
                </div>
                <div className="profile-status" />
              </div>
            </Col>

            {/* Info Blocks */}
            <InfoBlock
              Icon={PersonRoundedIcon}
              title="Name"
              value={fullName}
              iconBg="#FD75451A"
              iconBorder="#FD75451A"
              iconColor="#FD7545"
            />
            <InfoBlock
              Icon={PhoneInTalkRoundedIcon}
              title="Contact Number"
              value={contact}
              iconBg="#06B6D41A"
              iconBorder="#06B6D41A"
              iconColor="#06B6D4"
            />
            <InfoBlock
              Icon={CreditCardRoundedIcon}
              title="Account Number"
              value={account}
              iconBg="#8B5CF61A"
              iconBorder="#8B5CF61A"
              iconColor="#8B5CF6"
            />
          </Row>
        </CardBody>

        <div className="card-divider" />
      </Card>
    </div>
  );
}

function InfoBlock({ Icon, title, value, iconBg, iconBorder, iconColor }) {
  return (
    <Col
      md={3}
      sm={6}
      xs={12}
      className="d-flex align-items-start mt-4 info-block"
    >
      <div className="info-icon me-2" style={{ background: iconBg }}>
        <Icon fontSize="small" style={{ color: iconColor }} />
      </div>

      <div>
        <div className="info-title">{title}</div>
        <div className="info-value">{value}</div>
      </div>
    </Col>
  );
}

function getInitials(first, last) {
  const a = (first || "").trim().split(" ")[0] || "";
  const b = (last || "").trim().split(" ")[0] || "";
  if (!a && !b) return "G";
  if (!b) return a.charAt(0).toUpperCase();
  return `${a.charAt(0)}${b.charAt(0)}`.toUpperCase();
}
